<template>
  <div class="lg:flex lg:justify-center">
    <div
      class="p-2 items-center leading-none rounded-md flex lg:inline-flex"
      :class="[
      {'text-info': isInfo}, {'bag-info': isInfo},
      {'text-awro': isAwro}, {'bag-awro': isAwro},
      {'text-critical': !isInfo && !isAwro}, {'bag-critical': !isInfo && !isAwro}
      ]"
      role="alert"
    >
      <span
        class="flex rounded-full uppercase px-2 py-1 text-xs font-bold"
        :class="[{'badge-info': isInfo}, {'badge-awro': isAwro},, {'badge-critical': !isInfo && !isAwro}, {'mr-3': !isRtl}, {'ml-3': isRtl}]"
      >{{title}}</span>
      <template v-if="link">
        <a :href="link || '#'" class="font-semibold text-left flex-auto" :class="[{'mr-2': !isRtl}, {'ml-2': isRtl}]">{{ message }}</a>
      </template>
      <template v-else>
        <span class="font-semibold text-left flex-auto" :class="[{'mr-2': !isRtl}, {'ml-2': isRtl}]">{{ message }}</span>
      </template>
      <svg
        v-if="!isRtl"
        class="fill-current opacity-75 h-4 w-4"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
      >
        <path
          d="M12.95 10.707l.707-.707L8 4.343 6.586 5.757 10.828 10l-4.242 4.243L8 15.657l4.95-4.95z"
        />
      </svg>
      <svg v-else
      class="fill-current opacity-75 h-4 w-4"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20">
      <path d="M14.7 15.3C14.8444 15.4926 14.9146 15.7308 14.8975 15.9709C14.8804 16.211 14.7773 16.4369 14.6071 16.6071C14.4369 16.7773 14.211 16.8804 13.9709 16.8975C13.7308 16.9146 13.4926 16.8444 13.3 16.7L9.30002 12.7C9.11679 12.5131 9.01416 12.2618 9.01416 12C9.01416 11.7383 9.11679 11.4869 9.30002 11.3L13.3 7.30001C13.4926 7.15558 13.7308 7.08546 13.9709 7.10252C14.211 7.11959 14.4369 7.22269 14.6071 7.3929C14.7773 7.56311 14.8804 7.78901 14.8975 8.02912C14.9146 8.26923 14.8444 8.50744 14.7 8.70001L11.42 12L14.72 15.3H14.7Z"/>
      </svg>

    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
  name: "Alert",
  props: ["title", "type", "message", "link"],
  computed: {
    isInfo() {
      return this.type == "info";
    },
    isAwro() {
      return this.type == "awro";
    },
    ...mapGetters({
      isRtl: ['locale/IS_RTL']
    })
  }
};
</script>

<style>
.text-info {
    color: rgb(230, 230, 247);
}
.text-awro {
    color: #E6E9F7;
}
.text-critical {
    color: #E6F7F7;
}

.bag-info {
    background: #29335C;
}
.bag-awro {
    background: #00BFBC;
}
.bag-critical {
    background: #BD1D24;
}
.badge-info {
    background: #56618C;
}
.badge-awro {
    background: #41D9D6;
}
.badge-critical {
    background: #E7474E;
}
</style>
